import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToArray',
})
export class EnumToArrayPipe implements PipeTransform {
  transform(enumObj: object): Array<{ index: number | string; name: number | string; value: number | string; label: number | string }> {
    return Object.keys(enumObj)
      .filter(key => isNaN(Number(key)))
      .map(key => {
        const enumValue = enumObj[key as keyof typeof enumObj];
        return {
          // Old properties for backward compatibility
          index: enumValue,
          name: enumValue,
          // New properties for new pattern
          value: enumValue,
          label: enumValue,
        };
      });
  }
}
